import UsersListCreateEditDialog from './UsersListCreateEditDialog';
import UsersListInfoDialog from './UsersListInfoDialog';
import { useUsersListDialogContext } from '../context/UsersListDialogContext';

const UsersListDialogs = () => {
  const { state } = useUsersListDialogContext();

  switch (state.activeDialog) {
    case 'createUser':
      return <UsersListCreateEditDialog />;
    case 'editUser':
      return (
        <UsersListCreateEditDialog dialogType={'editUser'} userData={state?.data ?? undefined} />
      );
    case 'displayUserInfo':
      return state.data ? <UsersListInfoDialog userData={state.data} /> : null;
    default:
      return null;
  }
};

export default UsersListDialogs;
